import { checkoutApi } from "../../api/checkout";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { isEmpty } from "../../utils/common";
import {
  ChannelItemType,
  MethodItemType,
  OfferItemType,
  PaymentDataType,
  WalletName,
} from "../../models";
import {
  OFFER_CHANNEL,
  PAYMENT_CHANELS,
  PageName,
} from "../../constants/common";
import { StorageKEY } from "../../models";

export const fetchChanelAndMethod = createAsyncThunk(
  "checkout/fetchPaymentMethod",
  async () => {
    const response = await checkoutApi.fetchChanelAndMethod();
    return response;
  }
);

export const fetchPromotionsOffer = createAsyncThunk(
  "checkout/fetchPromotionsOffer",
  async ({
    titleId,
    channelType,
  }: {
    titleId: string;
    channelType: PageName | undefined;
  }) => {
    const response = await checkoutApi.getPromotionOffer({ titleId, channelType });

    let offer = {};
    if (response.error === 0) {
      const { nonPromotionOffers } = response.data;

      switch (channelType) {
        case PageName.SHOPEE: {
          offer = nonPromotionOffers.tvod[OFFER_CHANNEL.SHOPEEPAY][0] || {};
          break;
        }
        case PageName.VNPAY: {
          offer = nonPromotionOffers.tvod[OFFER_CHANNEL.VNPAY][0] || {};
          break;
        }
        case PageName.ZALO: {
          offer = nonPromotionOffers.tvod[OFFER_CHANNEL.ZALOPAY][0] || {};
          break;
        }
      }
    }
    localStorage.setItem(StorageKEY.offer, JSON.stringify(offer));
    return offer;
  }
);
export const setChannelAndMethod = createAction(
  "checkout/setChannelAndMethod",
  (args: { channel: ChannelItemType; method: MethodItemType }) => {
    const { channel, method } = args;
    return {
      payload: {
        channel,
        method,
      },
    };
  }
);
export const fetchPaymentChannelData = createAsyncThunk(
  "checkout/fetchPaymentChannelData",
  async ({
    channelType,
    clientId,
    returnUrl,
    offer,
  }: {
    channelType: string;
    clientId: string;
    returnUrl: string;
    offer: OfferItemType;
  }) => {
    let channelResponse: PaymentDataType = {};

    const response = await checkoutApi.syncPaymentMethod({
      channelType,
      clientId,
      returnUrl,
      offer,
    });
    let vnpModileData: { url: string } = { url: "" };
    if (channelType === PAYMENT_CHANELS["VNPAY-QR"]) {
      const vnpRespose = await checkoutApi.vnpayRedirectURL({
        offer: offer,
        returnUrl: returnUrl,
      });
      if (vnpRespose.error === 0) {
        vnpModileData.url = vnpRespose.data.url;
      }
    }
    if (response.error === 0) {
      const { data } = response;

      switch (channelType) {
        case PAYMENT_CHANELS.ZALOPAY: {
          channelResponse = {
            qrCodeUrl: data.url,
            token: data.token,
            resultCode: data.resultCode,
            key: data.key,
            message: data.message,
            deepLink: data.deeplink,
            notifyUrl: data.notifyUrl,
            redirectUrlWeb: data.deeplink,
          };
          break;
        }
        case PAYMENT_CHANELS.SHOPEEPAY: {
          channelResponse = {
            qrCodeUrl: data.qrcode_url,
            token: data.token,
            resultCode: data.resultCode,
            key: data.key,
            message: data.debug_msg,
            redirectUrlQr: data.redirect_url_qr,
            redirectUrlWeb: data.redirect_url_web,
            requestId: data.request_id,
          };
          break;
        }
        case PAYMENT_CHANELS["VNPAY-QR"]: {
          channelResponse = {
            qrCodeUrl: data.qr_code,
            token: data.token,
            redirectUrlWeb: vnpModileData.url,
          };
          break;
        }
      }
    }
    return {
      error: response.error,
      message: response.message,
      syncData: channelResponse,
    };
  }
);
